module.exports = __webpack_public_path__ + "static/media/Rich Brian ft. Joji - Where has the time gone.86208965.mp3";